import BaseLayout from '@/components/layouts/BaseLayout';
import LayoutBlank from '@/components/layouts/LayoutBlank';
import Main from '@/pages/Report/ReportRequests';

export default [
  {
    path: '/report',
    name: 'report',
    navbar: true,
    title: 'reports',
    icon: 'ion-ios-folder',
    meta: { perm: 'Navbar.Report' },
    component: BaseLayout,
    children: [
      {
        path: '/report',
        title: 'reports',
        icon: 'fas fa-folder-open',
        name: 'report',
        component: Main,
        hide: true,
        meta: { perm: 'Navbar.Report' },
      },
      {
        path: '',
        title: 'report_requests',
        icon: 'fas fa-download',
        component: Main,
        name: 'report_requests',
        meta: { perm: 'Report.Reports' },
      },
      {
        path: '',
        title: 'can_reports',
        icon: 'fas fa-folder-open',
        component: LayoutBlank,
        meta: { perm: 'Report.Reports' },
        children: [
          {
            report_id: 16,
            parent: 'can_reports',
            path: 'canbus',
            title: 'canbus_report',
            icon: 'fab fa-searchengin',
            name: 'canbus',
            meta: { perm: 'Report.CANBUSReport' },
            component: () => import('@/pages/Report/CANBUS'),
          },
          {
            report_id: 25,
            parent: 'can_reports',
            path: 'canbus_voyage',
            title: 'canbus_voyage_report',
            icon: 'fas fa-map',
            name: 'canbus_voyage',
            meta: { perm: 'Report.CANBUSReport' },
            component: () => import('@/pages/Report/CanVoyage'),
          },
          {
            report_id: 37,
            parent: 'can_reports',
            path: 'km_based_canbus',
            title: 'km_based_canbus_report',
            icon: 'fas fa-map',
            name: 'km_based_canbus',
            meta: { perm: 'Report.KMBasedCANBUSReport' },
            component: () => import('@/pages/Report/KmCanVoyage'),
          },
          {
            report_id: 39,
            parent: 'can_reports',
            path: 'canbus_fuel',
            title: 'canbus_fuel_report',
            icon: 'fas fa-map',
            name: 'canbus_fuel_report',
            meta: { perm: 'Report.CANBUSReport' },
            component: () => import('@/pages/Report/CANBUSFuel'),
          },
        ],
      },
      {
        path: '',
        title: 'reports',
        icon: 'fas fa-folder-open',
        component: LayoutBlank,
        meta: { perm: 'Report.Reports' },
        children: [
          {
            report_id: 20,
            parent: 'reports',
            path: 'vehicle_list',
            title: 'vehicle_list',
            icon: 'ion-ios-car',
            name: 'vehicle_list',
            meta: { perm: 'Report.Vehicle' },
            component: () => import('@/pages/Report/Vehicle'),
          },
          {
            report_id: 27,
            parent: 'reports',
            path: 'montage',
            title: 'montage_report',
            icon: 'ion-ios-car',
            name: 'montage',
            meta: { perm: 'Report.Montage' },
            component: () => import('@/pages/Report/Montage'),
          },
          {
            report_id: 11,
            parent: 'reports',
            path: 'entryExit',
            title: 'area_entrance-exitance_report',
            icon: 'fas fa-circle-notch',
            name: 'entryExit',
            meta: { perm: 'Report.EntryExit' },
            component: () => import('@/pages/Report/EntryExit'),
          },
          // Maximum Araç Giriş Çıkış Raporununun Görünmemesi İstendiği İçin Yoruma Alınmıştır.
          // {
          //     report_id: 10,
          //     parent: 'reports',
          //     path: 'maxInOutRep',
          //     title: 'max_entrance-exitance_report',
          //     icon: 'ion-ios-compass',
          //     name: 'maxInOutRep',
          //     meta: { perm: 'Report.MaxInOutRep' },
          //     component: () =>
          //         import ('@/pages/Report/MaxInOut'),
          // },
          {
            report_id: 2,
            parent: 'reports',
            path: 'vehicleAct',
            title: 'vehicle_activity_report',
            icon: 'ion-ios-car',
            name: 'vehicleAct',
            meta: { perm: 'Report.VehicleAct' },
            component: () => import('@/pages/Report/VehicleAct'),
          },
          // Aşırı hız raporu "hız raporu" ile birleştirildi.
          // {
          //     report_id: 4,
          //     parent: 'reports',
          //     path: 'speedReportWithLimit',
          //     title: 'over_speed_report',
          //     icon: 'ion-ios-speedometer',
          //     name: 'speedReportWithLimit',
          //     meta: { perm: 'Report.SpeedReport' },
          //     component: () =>
          //         import ('@/pages/Report/SpeedWithLimit'),
          // },
          {
            report_id: 38,
            parent: 'reports',
            path: 'device_battery_report',
            title: 'device_battery_report',
            icon: 'fas fa-battery-half',
            name: 'device_battery_report',
            meta: { perm: 'Report.DeviceBatteryReport' },
            component: () => import('@/pages/Report/DeviceBattery'),
          },
          {
            report_id: 3,
            parent: 'reports',
            path: 'kmDetail',
            title: 'detailed_KM_report',
            icon: 'fas fa-road',
            name: 'kmDetail',
            meta: { perm: 'Report.KmDetail' },
            component: () => import('@/pages/Report/KmDetail'),
          },
          {
            report_id: 6,
            parent: 'reports',
            path: 'pastLoc',
            title: 'past_location_report',
            icon: 'fas fa-history',
            name: 'pastLoc',
            meta: { perm: 'Report.PastLoc' },
            component: () => import('@/pages/Report/PastLoc'),
          },
          {
            report_id: 35,
            parent: 'reports',
            path: 'input_device_report',
            title: 'input_device_report',
            icon: 'ion-ios-car',
            name: 'input_device_report',
            meta: { perm: 'Report.InputDeviceReport' },
            component: () => import('@/pages/Report/InputDevice'),
          },
          {
            report_id: 1,
            parent: 'reports',
            path: 'endDay',
            title: 'end_day_report',
            icon: 'ion-md-calendar',
            name: 'endDay',
            meta: { perm: 'Report.EndDay' },
            component: () => import('@/pages/Report/EndDay'),
          },
          {
            report_id: 8,
            parent: 'reports',
            path: 'speedRep',
            title: 'speed_report',
            icon: 'ion-ios-speedometer',
            name: 'speedRep',
            meta: { perm: 'Report.SpeedRep' },
            component: () => import('@/pages/Report/Speed'),
          },
          {
            report_id: 12,
            parent: 'reports',
            path: 'highways',
            title: 'highways_report',
            icon: 'fas fa-road',
            name: 'highways',
            meta: { perm: 'Report.RoadWays' },
            component: () => import('@/pages/Report/Highways'),
          },
          {
            report_id: 18,
            parent: 'reports',
            path: 'kmRep',
            title: 'kilometer_report',
            icon: 'fas fa-road',
            name: 'kmRep',
            meta: { perm: 'Report.KMRep' },
            component: () => import('@/pages/Report/KM'),
          },
          {
            report_id: 19,
            parent: 'reports',
            path: 'ignition',
            title: 'ignition_report',
            icon: 'ion-ios-speedometer',
            name: 'ignition',
            meta: { perm: 'Report.Ignition' },
            component: () => import('@/pages/Report/Ignition'),
          },
          {
            report_id: 7,
            parent: 'reports',
            path: 'outShift',
            title: 'off-shift_use_report',
            icon: 'fa fa-hourglass-end',
            name: 'outShift',
            meta: { perm: 'Report.OutShift' },
            component: () => import('@/pages/Report/OutShift'),
          },
          {
            report_id: 23,
            parent: 'reports',
            path: 'average_temperature',
            title: 'average_temperature_report',
            icon: 'fas fa-temperature-high',
            name: 'average_temperature',
            meta: { perm: 'Report.AverageTemperature' },
            component: () => import('@/pages/Report/AverageTemperature'),
          },
          {
            report_id: 24,
            parent: 'reports',
            path: 'summary',
            title: 'summary_report',
            icon: 'ion-md-calendar',
            name: 'summary',
            meta: { perm: 'Report.EndDay' },
            component: () => import('@/pages/Report/Summary'),
          },
          {
            report_id: 5,
            parent: 'reports',
            path: 'parkRep',
            title: 'park_report',
            icon: 'fas fa-parking',
            name: 'parkRep',
            meta: { perm: 'Report.ParkRep' },
            component: () => import('@/pages/Report/Park'),
          },
          {
            report_id: 15,
            parent: 'reports',
            path: 'rfidCardRep',
            title: 'RFID_card_report',
            icon: 'fas fa-id-card',
            name: 'rfidCardRep',
            meta: { perm: 'Report.RfidCardRep' },
            component: () => import('@/pages/Report/RfidCard'),
          },
          {
            report_id: 26,
            parent: 'reports',
            path: 'QrCodeReport',
            title: 'qr_code_report',
            icon: 'ion ion-md-qr-scanner',
            name: 'QrCodeReport',
            meta: { perm: 'Report.QrCodeRep' },
            component: () => import('@/pages/Report/QrCodeReport'),
          },
          {
            report_id: 17,
            parent: 'reports',
            path: 'idling',
            title: 'idling_report',
            icon: 'ion-ios-speedometer',
            name: 'idling',
            meta: { perm: 'Report.Idling' },
            component: () => import('@/pages/Report/Idling'),
          },
          {
            report_id: 0,
            parent: 'reports',
            path: 'voyageRep',
            title: 'journey_report',
            icon: 'ion-ios-car',
            name: 'voyageRep',
            meta: { perm: 'Report.VoyageRep' },
            component: () => import('@/pages/Report/Voyage'),
          },
          {
            report_id: 13,
            parent: 'reports',
            path: 'temperature',
            title: 'temperature_report',
            icon: 'fas fa-temperature-high',
            name: 'temperature',
            meta: { perm: 'Report.Temperature' },
            component: () => import('@/pages/Report/Temperature'),
          },
          {
            report_id: 9,
            parent: 'reports',
            path: 'driverRep',
            title: 'driver_based_activity_report',
            icon: 'fas fa-user-circle',
            name: 'driverRep',
            meta: { perm: 'Report.DriverReport' },
            component: () => import('@/pages/Report/Driver'),
          },
          {
            report_id: 14,
            parent: 'reports',
            path: 'driverperformance',
            title: 'driver_performance_report',
            icon: 'fas fa-car-crash',
            name: 'driverperformance',
            meta: { perm: 'Report.DriverPerformance' },
            component: () => import('@/pages/Report/DriverPerformance'),
          },
          {
            report_id: 34,
            parent: 'reports',
            path: 'trigger_device_report',
            title: 'trigger_device_report',
            icon: 'ion-ios-car',
            name: 'trigger_device_report',
            meta: { perm: 'Report.TriggerReport' },
            component: () => import('@/pages/Report/TriggerDevice'),
          },
          {
            report_id: 22,
            parent: 'reports',
            path: 'fuel_report',
            title: 'fuel_report',
            icon: 'fas fa-gas-pump',
            name: 'fuel_report',
            meta: { perm: 'Report.DriverPerformance' },
            component: () => import('@/pages/Report/FuelIntegration'),
          },
          {
            report_id: 36,
            parent: 'reports',
            path: 'check_reports',
            title: 'check_reports',
            icon: 'fas fa-gas-pump',
            name: 'check_reports',
            meta: { perm: 'Report.DriverPerformance' },
            component: () => import('@/pages/Report/CheckReports'),
          },
        ],
      },
      {
        path: '',
        title: 'automatic_reporting',
        icon: 'fas fa-folder',
        name: 'auto_report_list',
        component: LayoutBlank,
        meta: { perm: 'Pages.AutoReportList' },
        children: [
          {
            path: 'auto_report_list',
            title: 'automatic_reporting',
            icon: 'fas fa-folder-open',
            name: 'auto_report_list',
            component: () => import('@/pages/Report/AutoReport/AutoReportList'),
            meta: { perm: 'Pages.AutoReportList' },
          },
          {
            path: 'set_auto_report',
            title: 'add_automatic_report',
            icon: 'fas fa-folder-open',
            name: 'set_auto_report',
            hide: true,
            component: () => import('@/pages/Report/AutoReport/SetAutoReport'),
            meta: { perm: 'Pages.NewAutoReport' },
          },
          {
            path: 'edit_auto_report',
            title: 'edit_automatic_report',
            icon: 'fas fa-folder-open',
            name: 'edit_auto_report',
            hide: true,
            component: () => import('@/pages/Report/AutoReport/SetAutoReport'),
            meta: { perm: 'Pages.EditAutoReport' },
          },
          {
            path: 'auto_report_info_list',
            title: 'automatic_report_submission_report',
            icon: 'fas fa-file-archive',
            name: 'auto_report_info_list',
            component: () => import('@/pages/Report/AutoReport/AutoReportInfo'),
            meta: { perm: 'Pages.AutoReportInfoList' },
          },
        ],
      },
      {
        path: '',
        title: 'automatic_reporting',
        icon: 'fas fa-folder',
        name: 'auto_report_list',
        component: LayoutBlank,
        meta: { perm: 'Pages.AutoReportList' },
        children: [
          {
            path: 'auto_report_list',
            title: 'automatic_reporting',
            icon: 'fas fa-folder-open',
            name: 'auto_report_list',
            component: () => import('@/pages/Report/AutoReport/AutoReportList'),
            meta: { perm: 'Pages.AutoReportList' },
          },
          {
            path: 'set_auto_report',
            title: 'add_automatic_report',
            icon: 'fas fa-folder-open',
            name: 'set_auto_report',
            hide: true,
            component: () => import('@/pages/Report/AutoReport/SetAutoReport'),
            meta: { perm: 'Pages.NewAutoReport' },
          },
          {
            path: 'edit_auto_report',
            title: 'edit_automatic_report',
            icon: 'fas fa-folder-open',
            name: 'edit_auto_report',
            hide: true,
            component: () => import('@/pages/Report/AutoReport/SetAutoReport'),
            meta: { perm: 'Pages.EditAutoReport' },
          },
          {
            path: 'auto_report_info_list',
            title: 'automatic_report_submission_report',
            icon: 'fas fa-file-archive',
            name: 'auto_report_info_list',
            component: () => import('@/pages/Report/AutoReport/AutoReportInfo'),
            meta: { perm: 'Pages.AutoReportInfoList' },
          },
        ],
      },
      {
        path: '',
        title: 'automatic_reporting',
        icon: 'ion ion-md-git-network',
        component: LayoutBlank,
        children: [
          {
            path: 'automatic_report',
            title: 'automatic_reporting',
            icon: 'ion ion-md-git-network',
            name: 'automatic_report',
            meta: { perm: 'Report.AutomaticReport' },
            component: () => import('@/pages/Management/FleetManagement/FleetProcess/Fleets'),
          },
        ],
      },
    ],
  },
];
